"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uuid_1 = require("uuid");
const NodeBuilder_1 = __importDefault(require("./NodeBuilder"));
const questionnaireBlueprints_1 = require("../../../types/questionnaireBlueprints/questionnaireBlueprints");
class SectionGroupBuilder extends NodeBuilder_1.default {
    sectionGroupKey = null;
    constructor(seedProviders) {
        super(seedProviders.forSectionGroup());
        this.node.id = (0, uuid_1.v4)();
    }
    withProperties(properties) {
        Object.assign(this.node, properties);
        return this.clone();
    }
    withSectionGroupKey(sectionGroupKey) {
        this.sectionGroupKey = sectionGroupKey;
        return this.clone();
    }
    getSectionGroupKey() {
        return this.sectionGroupKey;
    }
    withPartName(partname) {
        this.node.partName = partname;
        return this.clone();
    }
    withTitle(title) {
        this.node.title = title;
        return this.clone();
    }
    visibleIf(condition) {
        this.node.visible = condition;
        return this.clone();
    }
    repeatable(options) {
        this.node.repeatable = {
            repeatableAnswerNodeId: options.repeatableAnswerNodeId,
            minRepeatable: 1,
            maxRepeatable: 6,
        };
        return this.clone();
    }
    validate(section) {
        return (0, questionnaireBlueprints_1.isSectionBlueprint)(section);
    }
}
exports.default = SectionGroupBuilder;
